import React, { useState, useEffect } from "react";
import BasicModal from 'src/components/Modal';
import MediaFrom from 'src/components/media/MediaFrom';
import AxiosInstance from "../Axios";
import { CButton } from "@coreui/react";
import { confirmAlert } from "react-confirm-alert";

const ProductDocuments = (props) => {
  // console.log('ProductDocuments props', props);

  const urlApi_1 = "/documents";
  const urlApi_2 = "/media_objects";

  // Текст для popup
  const popupTextSuccess_1 = "Файл додано";
  const popupTextSuccess_2 = "Файл видалено";
  const popupTextError = "Помилка запиту";

  const [productId, setProductId] = useState(null);
  const [document, setDocument] = useState(null);

  const [newMediaId, setNewMediaId] = useState(false);
  const [newMediaName, setNewMediaName] = useState("");
  const [mediaIdForDelete, setMediaIdForDelete] = useState(null);
  const [showModalMedia, setShowModalMedia] = useState(true);

  const getDocument = async (id) => {
    try {
      const response = await AxiosInstance(`${urlApi_1}?product.id=${id}`);
      // console.log('response', response);
      if (response.data["hydra:member"].length > 0) {
        setDocument(response.data["hydra:member"][0]);
      } else {
        setDocument(null);
      };
    } catch (error) {
      console.error("Помилку запиту за документом: ", error);
    };
  };

  useEffect(() => {
    if (props.productId) {
      setProductId(props.productId);
      getDocument(props.productId);
    };
  }, [props.productId]);

  // Підготувати id media для видалення
  useEffect(() => {
    if (document?.media?.id) {
      setMediaIdForDelete(document.media.id);
    };
  }, [document]);

  // Для модального вікна "Додати інструкцію"
  const actionShowModalMedia = (rez) => {
    setShowModalMedia(rez);
    // console.log('rez', rez);
    // if (!rez)
    // UpdateMedia();
  };

  // Відслідковувати створення нової інструкції
  useEffect(() => {
    if (newMediaId !== false) {
      // console.log('newMediaId != false', newMediaId);
      const article = {
        media: `/api/media_objects/${newMediaId}`,
        product: `/api/products/${productId}`,
        dateEntered: new Date(),
        name: newMediaName,
      };
      // Додати інструкцію до товару
      // console.log('article', article);
      addMedia(article);
    };
  }, [newMediaId]);

  // Функція для додавання інструкції до товару
  const addMedia = async (article) => {
    try {
      const response = await AxiosInstance.post(urlApi_1, article);
      // console.log('post document response', response);

      // Якщо до товару раніше вже була додана інструкція, то видалити її та media_objects
      if (mediaIdForDelete) {
        deleteDocument();
      } else {
        getDocument(productId);
      };

      // Обнулити нову інструкцію
      setNewMediaId(false);
      setNewMediaName("");
      // Вивести повідомлення про успішні зміни
      props.toastifySuccess(popupTextSuccess_1);
    } catch (error) {
      console.error("Помилка запиту на створення документу: ", error);
      props.toastifyWarning(popupTextError);
    };
  };

  // Функція для видалення інструкції з media_objects
  const deleteMediaObject = async () => {
    try {
      const response = await AxiosInstance.delete(`${urlApi_2}/${mediaIdForDelete}`);
      // console.log('media_objects/id delete response', response);
      console.log("Файл видалено з media_objects");
    } catch (error) {
      console.error("Помилка запиту на видалення файлу", error);
      props.toastifyWarning(popupTextError);
    };
  };

  // Функція для видалення documents інструкції з media_objects
  const deleteDocument = async () => {
    try {
      const response = await AxiosInstance.delete(`${urlApi_1}/${document.id}`);
      // console.log('document/id delete response', response);
      deleteMediaObject();
      // console.log("Документ видалено");

      setMediaIdForDelete(null);
      props.toastifySuccess(popupTextSuccess_2);
    } catch (error) {
      console.error("Помилка запиту видалення документу", error);
      props.toastifyWarning(popupTextError);
    } finally {
      getDocument(productId);
    };
  };

  // Видалити інструкцію з товару
  function Deleted() {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити інструкцію ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            deleteDocument();
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  return (
    <>
      <h3>{document?.name}</h3>
      <div className="d-flex my-3">
        <div>
          {
            (document?.media?.contentUrl) &&
            <div className="mb-3 me-3">
              <a href={process.env.REACT_APP_SERVER_URL + document.media.contentUrl} target="_blank">
                <CButton color="secondary" onClick={() => { }}>Переглянути інструкцію</CButton>
              </a>
            </div>
          }
        </div>
        <div className="mb-3 me-3">
          <BasicModal
            show={showModalMedia}
            actionShowModal={actionShowModalMedia}
            title={`Додати інструкцію до товару`}
            btn_name={(document) ? "Змінити інструкцію" : "Додати інструкцію"}
            content={
              <MediaFrom
                actionShowModal={actionShowModalMedia}
                toastifySuccess={props.toastifySuccess}
                type="document" setNewMediaId={setNewMediaId}
                textSuccess="Файл додано" setNewMediaName={setNewMediaName}
              />
            }
          />
        </div>
        {/* Кнопка для видалення інструкції */}
        {
          (document?.media?.contentUrl) &&
          <div className="mb-3">
            <CButton color="secondary" onClick={() => Deleted()}>Видалити інструкцію</CButton>
          </div>
        }
      </div>
    </>
  );
};

export default ProductDocuments;